var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReactivate2020(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25835 0.315019C2.59775 -0.0911593 1.76754 -0.10455 1.09356 0.274847C0.419569 0.654245 0 1.3684 0 2.14505V17.8566C0 18.6332 0.419569 19.3474 1.09356 19.7268C1.76754 20.1062 2.59775 20.0883 3.25835 19.6866L16.1132 11.8308C16.7515 11.4425 17.1398 10.7507 17.1398 10.0008C17.1398 9.25094 16.7515 8.56356 16.1132 8.17077L3.25835 0.315019Z",
    fill: "#61A578"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactivate2020);
export default __webpack_public_path__ + "static/media/Reactivate_20_20.06cbb3f57f2ab336080afd9e6b874850.svg";
export { ForwardRef as ReactComponent };